module.exports = __webpack_public_path__ + "static/media/disappointed2.3d278bee.gif";


//////////////////
// WEBPACK FOOTER
// ./src/images/disappointed2.gif
// module id = 864
// module chunks = 0